const usabillaConfig = {
  url: '//w.usabilla.com/af4dce1bafdd.js',
  localeMap: {
    de: 'German',
    en: '',
    es: 'Spanish',
    fr: 'French',
    it: 'Italian',
    ja: 'Japan',
    ko: 'Korean',
    pt: 'Portuguese',
    ru: 'Russian',
    zh: 'ChineseTraditional',
    'zh-hans': 'Chinese',
  },
}

export default usabillaConfig
